import _ from "lodash"

export default  function somataorio(valores: Number[]){
console.log(valores)
     const num =  _.sum(valores)
     return num.toString()

}